/** When your routing table is too long, you can split it into small modules**/

import Layout from '@/views/layout/Layout'

const componentsRouter = {
    path: '/talkback',
    component: Layout,
    name: 'Talkback',
    menuid: 131,
    systemtypeid:5,
    meta: {
      title: 'TalkbackTitle',
      icon: 'peoples'
    },
    children: [ 
      {
        path: 'device/index',
        component: () => import('@/views/talkback/device/list'),
        name: 'TalkbackDeviceList',
        menuid: 132,
        systemtypeid:5,
        meta: {title: 'DeviceList', icon: 'wechat'}
      },  
    ]
  }

export default componentsRouter



// WEBPACK FOOTER //
// ./src/router/modules/talkback.js